/*eslint-disable */
define(function(require) {
    var Backbone = require('backbone');
    var xhrUris = require('common/xhr-uris');

    return Backbone.Model.extend({
        url  : xhrUris.authenticatedCustomer
    });
});
